<template>
  <div class="inventory-center">
    <!-- 左侧时间导航菜单 -->
    <div class="sidebar">
      <el-card class="nav-card" shadow="never">
        <div class="nav-header">
          <h3 class="nav-title">盘货中心</h3>
          <p class="nav-subtitle">按时间管理</p>
        </div>
        <el-menu 
          default-active="0" 
          class="nav-menu" 
          @select="beforeFindItem"
        >
          <el-menu-item 
            v-for="inventory in inventoryTime" 
            :key="inventory.id" 
            :index="inventory.id + ''"
          >
            <i class="el-icon-date"></i>
            <span>{{ inventory.time }}</span>
          </el-menu-item>
        </el-menu>
      </el-card>
    </div>

    <!-- 主要内容区域 -->
    <div class="main-content">
      <div class="content-section">
        <el-card class="content-card" shadow="always" v-if="selectInventoryId !== ''">
          <div class="card-header">
            <div class="header-info">
              <h2 class="section-title">商品列表</h2>
              <el-tag type="info" size="small" class="count-tag">
                共 {{ items.length }} 个商品
              </el-tag>
            </div>
            <div class="header-actions">
              <el-button 
                type="primary" 
                icon="el-icon-download"
                @click="downExcle"
                class="export-btn"
              >
                导出
              </el-button>
            </div>
          </div>

          <!-- 状态切换和搜索 -->
          <div class="filter-section">
            <el-radio-group v-model="tableState" @input="findItem" class="status-radio">
              <el-radio-button label="Stocked">已盘货</el-radio-button>
              <el-radio-button label="UnStocked">未盘货</el-radio-button>
            </el-radio-group>
          </div>
          <el-table
            :data="items.filter(data => !tableSearch || data.name.toLowerCase().includes(tableSearch.toLowerCase()) || data.brand.toLowerCase().includes(tableSearch.toLowerCase()) || data.properties.toLowerCase().includes(tableSearch.toLowerCase()))"
            :max-height="tableHight"
            class="inventory-table"
            :empty-text="loadInfo"
            stripe
            v-if="tableState !== ''"
          >
            <el-table-column
              label="序号"
              type="index"
              width="80"
              align="center"
            />

            <el-table-column
              label="品牌名称"
              prop="brand"
              min-width="15%"
              class-name="brand-column"
            >
              <template slot-scope="{ row }">
                <div class="brand-cell">
                  <el-tag 
                    v-if="row.brand" 
                    size="small" 
                    type="primary"
                    class="brand-tag"
                  >
                    {{ row.brand }}
                  </el-tag>
                  <span v-else class="empty-text">-</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column type="expand">
              <template slot-scope="props">
                <div class="expand-content">
                  <el-row :gutter="20">
                    <el-col :span="12">
                      <div class="detail-item">
                        <label>品牌名称:</label>
                        <span>{{ props.row.brand || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>商品名称:</label>
                        <span>{{ props.row.name || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>所属店铺:</label>
                        <span>{{ props.row.shop || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>商品属性:</label>
                        <span>{{ props.row.properties || '-' }}</span>
                      </div>
                    </el-col>
                    <el-col :span="12">
                      <div class="detail-item">
                        <label>商品规格:</label>
                        <span>{{ props.row.specs || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>商品位置:</label>
                        <span>{{ props.row.location || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>直播价:</label>
                        <span class="price">{{ props.row.lowPrice || '-' }}</span>
                      </div>
                      <div class="detail-item">
                        <label>商品已拥有:</label>
                        <span>{{ props.row.hasString || '-' }}</span>
                      </div>
                    </el-col>
                  </el-row>
                  <div class="detail-item full-width" v-if="props.row.description">
                    <label>商品描述:</label>
                    <span>{{ props.row.description }}</span>
                  </div>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="商品名称"
              prop="name"
              min-width="25%"
              class-name="name-column"
            >
              <template slot-scope="{ row }">
                <div class="name-cell">
                  <span class="product-name">{{ row.name || '-' }}</span>
                  <span class="product-shop" v-if="row.shop">{{ row.shop }}</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column
              label="属性"
              prop="properties"
              min-width="15%"
              class-name="properties-column"
            >
              <template slot-scope="{ row }">
                <div class="properties-cell">
                  <el-tag 
                    v-if="row.properties" 
                    size="small" 
                    type="info"
                    class="property-tag"
                  >
                    {{ row.properties }}
                  </el-tag>
                  <span v-else class="empty-text">-</span>
                </div>
              </template>
            </el-table-column>

            <el-table-column 
              label="操作" 
              min-width="25%"
              class-name="action-column"
            >
              <template slot="header">
                <el-input 
                  v-model="tableSearch" 
                  size="small" 
                  placeholder="搜索商品信息"
                  prefix-icon="el-icon-search"
                  class="search-input"
                />
              </template>
              <template slot-scope="scope">
                <div class="action-buttons">
                  <el-button 
                    v-if="tableState === 'Stocked'"
                    size="small"
                    type="primary"
                    icon="el-icon-view"
                    @click="show(scope.$index, scope.row)"
                    class="action-btn view-btn"
                  >
                    查看
                  </el-button>
                  <el-button 
                    v-if="tableState === 'Stocked'"
                    size="small"
                    type="danger"
                    icon="el-icon-remove"
                    @click="handleMoveFromInventory(scope.$index, scope.row)"
                    class="action-btn remove-btn"
                  >
                    移除盘货
                  </el-button>
                  <el-button 
                    v-if="tableState === 'UnStocked'"
                    size="small"
                    type="success"
                    icon="el-icon-plus"
                    @click="handleAddToInventory(scope.$index, scope.row)"
                    class="action-btn add-btn"
                  >
                    加入盘货
                  </el-button>
                </div>
              </template>
            </el-table-column>
          </el-table>
        </el-card>

        <!-- 空状态 -->
        <div v-else class="empty-state">
          <i class="el-icon-goods"></i>
          <p>请选择盘货时间</p>
        </div>
      </div>

      <!-- 底部操作按钮 -->
      <div class="bottom-actions">
        <el-button
          type="primary"
          icon="el-icon-plus"
          @click="dialogFormVisible = true"
          class="create-btn"
        >
          创建盘货
        </el-button>
        <el-button
          type="danger"
          icon="el-icon-delete"
          @click="handlBeforeMoveInventory"
          class="delete-btn"
        >
          删除盘货
        </el-button>
      </div>
    </div>

    <!-- 创建盘货对话框 -->
    <el-dialog 
      title="创建盘货" 
      :visible.sync="dialogFormVisible"
      width="500px"
      class="custom-dialog"
    >
      <el-form :model="createForm" label-width="120px" class="dialog-form">
        <el-form-item label="选择月份">
          <el-date-picker 
            v-model="creatInventoryTime" 
            type="month" 
            placeholder="选择月份"
            style="width: 100%"
          />
        </el-form-item>
      </el-form>
      <div slot="footer" class="dialog-footer">
        <el-button @click="dialogFormVisible = false">取 消</el-button>
        <el-button type="primary" @click="creatInventory">确 定</el-button>
      </div>
    </el-dialog>
    </div>
</template>

<script>
import Common from '@/components/Common'
import { inventoryApi } from '@/api'
export default {
  name: 'Inventory',
  data () {
    return {
      tableHight: window.innerHeight * 0.65,
      dialogFormVisible: false,
      creatInventoryTime: '',
      selectInventoryId: '',
      selectInventoryTime: '',
      inventoryTime: [],
      items: [],
      stockedItems: [],
      unStockedItems: [],
      tableState: '',
      stockedNum: 0,
      unStockedNum: 0,
      loadInfo: '暂无数据',
      tableSearch: ''
    }
  },
  mounted () {
    this.getAllInventory()
  },
  methods: {
    show (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/show',
        query: {
          id: row.id
        }
      })
      window.open(routeUrl.href, '_blank')
      console.log(row.id)
    },
    beforeFindItem (key, keyPath) {
      this.selectInventoryId = key
      this.tableState = ''
      for (var i in this.inventoryTime) {
        if (this.inventoryTime[i].id === this.selectInventoryId) {
          this.selectInventoryTime = this.inventoryTime[i].time
        }
      }
      // this.findItem(true)
      // this.findItem(false)
      // this.tableState = 'Stocked'
      // this.fillTable()
    },
    async findItem () {
      this.items = []
      let flag = true
      if (this.tableState === 'UnStocked') flag = false
      this.loadInfo = '数据加载中'

      try {
        const response = await inventoryApi.findItemByInventoryId(this.selectInventoryId, flag)
        this.loadInfo = '数据加载完毕，暂无数据'
        this.items = response
        for (let i in this.items) {
          let hasList = this.items[i].has
          this.items[i].hasString = hasList.join(' · ')
        }
      } catch (error) {
        console.error('获取盘货商品失败:', error)
        this.$message.error('获取盘货商品失败')
      }
    },
    fillTable () {
      if (this.tableState === 'Stocked') this.items = this.stockedItems
      else this.items = this.unStockedItems
    },
    async getAllInventory () {
      try {
        const response = await inventoryApi.getAllInventory()
        this.inventoryTime = []
        for (var i in response) {
          let s = response[i].time
          let time = s.substring(0, s.indexOf(' '))
          let live = {id: response[i].id, time: time}
          this.inventoryTime.push(live)
        }
      } catch (error) {
        console.error('获取盘货时间失败:', error)
        this.$message.error('获取盘货时间失败')
      }
    },
    async creatInventory () {
      if (this.creatInventoryTime === '') {
        this.$message.warning('请输入时间')
        return
      }

      try {
        await inventoryApi.createInventory(this.creatInventoryTime)
        this.getAllInventory()
        this.dialogFormVisible = false
        this.$message.success('创建盘货日期成功！')
      } catch (error) {
        console.error('创建盘货时间失败:', error)
        this.$message.error('创建盘货时间失败')
      }
    },
    async handleMoveFromInventory (index, row) {
      try {
        await inventoryApi.removeFromInventory(this.selectInventoryId, row.id)
        this.items.splice(index, 1)
        this.findItem(true)
        this.findItem(false)
        this.$message.success('移除成功')
      } catch (error) {
        console.error('移除商品失败:', error)
        this.$message.error('移除商品失败')
      }
    },
    async handleMoveInventory () {
      try {
        await inventoryApi.deleteInventory(this.selectInventoryId)
        this.$message.success('删除成功！')
        this.getAllInventory()
        this.selectInventoryId = ''
        this.selectInventoryTime = ''
      } catch (error) {
        console.error('删除盘货时间失败:', error)
        this.$message.error('删除盘货时间失败')
      }
    },
    handlBeforeMoveInventory () {
      if (this.selectInventoryTime === '') {
        this.$message.warning('请重新选择盘货日期')
        return
      }
      this.$confirm('是否删除盘货日期  ' + this.selectInventoryTime + '  ?', '提示', {
        confirmButtonText: '确定',
        cancelButtonText: '取消',
        type: 'warning'
      }).then(() => {
        this.handleMoveInventory()
      }).catch(() => {
        this.$message({
          type: 'info',
          message: '已取消删除'
        })
      })
    },
    handleAddToInventory (index, row) {
      const routeUrl = this.$router.resolve({
        path: '/update',
        query: {
          id: row.id,
          timeId: this.selectInventoryId
        }
      })
      window.open(routeUrl.href, '_blank')
    },
    downExcle () {
      let flag = true
      if (this.tableState === 'UnStocked') flag = false
      this.$axios({
        // 这里也可以是 blob
        responseType: 'blob',
        method: 'post',
        url: Common.baseUrl + 'inventoryHasGoods/downLoadInventory',
        params: {inventoryId: this.selectInventoryId, flag: flag}
      }).then((res) => {
        console.log(123)
        console.log(res)
        let code = res.status
        console.log(code)
        if (code === 200) {
          const { data, headers } = res
          const fileName = headers['content-disposition'].replace(/\w+;filename=(.*)/, '$1')
          // 此处当返回json文件时需要先对data进行JSON.stringify处理，其他类型文件不用做处理
          const blob = new Blob([data], {type: headers['content-type']})
          let dom = document.createElement('a')
          let url = window.URL.createObjectURL(blob)
          dom.href = url
          dom.download = decodeURI(fileName)
          dom.style.display = 'none'
          document.body.appendChild(dom)
          dom.click()
          dom.parentNode.removeChild(dom)
          window.URL.revokeObjectURL(url)
        } else if (code === 401) {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
          this.$router.push('/login')
        } else {
          this.$message({
            message: res.data.msg,
            type: 'warning'
          })
        }
      }).catch(error => {
        this.$message({
          message: error,
          type: 'warning'
        })
      })
    }
  }
}
</script>

<style scoped>
.inventory-center {
  display: flex;
  min-height: 100vh;
  background-color: #f5f7fa;
  gap: 20px;
  padding: 20px;
}

/* 左侧导航栏 */
.sidebar {
  width: 280px;
  flex-shrink: 0;
}

.nav-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

.nav-header {
  text-align: center;
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}

.nav-title {
  font-size: 20px;
  font-weight: 600;
  color: #303133;
  margin: 0 0 8px 0;
}

.nav-subtitle {
  font-size: 14px;
  color: #909399;
  margin: 0;
}

.nav-menu {
  border: none;
}

.nav-menu .el-menu-item {
  height: 50px;
  line-height: 50px;
  margin: 8px 16px;
  border-radius: 8px;
  transition: all 0.3s ease;
}

.nav-menu .el-menu-item:hover {
  background-color: #ECF5FF;
  color: #409EFF;
}

.nav-menu .el-menu-item.is-active {
  background-color: #409EFF;
  color: white;
}

.nav-menu .el-menu-item i {
  margin-right: 12px;
  font-size: 16px;
}

/* 主要内容区域 */
.main-content {
  flex: 1;
  min-width: 0;
  display: flex;
  flex-direction: column;
}

.content-section {
  flex: 1;
  min-width: 0;
}

.content-card {
  border-radius: 12px;
  border: none;
  box-shadow: 0 2px 12px rgba(0, 0, 0, 0.1);
}

/* 卡片头部 */
.card-header {
  display: flex;
  align-items: center;
  justify-content: space-between;
  padding: 20px 0;
  border-bottom: 1px solid #EBEEF5;
  margin-bottom: 20px;
}

.header-info {
  display: flex;
  align-items: center;
  gap: 12px;
}

.section-title {
  font-size: 18px;
  font-weight: 600;
  color: #303133;
  margin: 0;
}

.count-tag {
  background-color: #F4F4F5;
  color: #909399;
  border: none;
}

.header-actions {
  display: flex;
  gap: 12px;
}

.export-btn {
  border-radius: 8px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.export-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 筛选区域 */
.filter-section {
  margin-bottom: 20px;
  padding: 15px 0;
  border-bottom: 1px solid #EBEEF5;
}

.status-radio {
  display: flex;
  gap: 8px;
}

.status-radio .el-radio-button__inner {
  border-radius: 8px;
  border: 1px solid #DCDFE6;
  padding: 8px 16px;
  font-weight: 500;
  transition: all 0.3s ease;
}

.status-radio .el-radio-button__orig-radio:checked + .el-radio-button__inner {
  background-color: #409EFF;
  border-color: #409EFF;
  color: white;
}

/* 表格样式 */
.inventory-table {
  border-radius: 8px;
  overflow: hidden;
}

.brand-cell .brand-tag {
  background-color: #ECF5FF;
  color: #409EFF;
  border-color: #B3D8FF;
}

.name-cell {
  display: flex;
  flex-direction: column;
  gap: 4px;
}

.product-name {
  font-weight: 500;
  color: #303133;
}

.product-shop {
  font-size: 12px;
  color: #909399;
}

.properties-cell .property-tag {
  background-color: #F4F4F5;
  color: #909399;
  border-color: #D3D4D6;
}

.empty-text {
  color: #C0C4CC;
  font-style: italic;
}

/* 展开内容 */
.expand-content {
  padding: 20px;
  background-color: #FAFAFA;
  border-radius: 8px;
  margin: 10px;
}

.detail-item {
  display: flex;
  margin-bottom: 12px;
  align-items: flex-start;
}

.detail-item.full-width {
  flex-direction: column;
  gap: 8px;
}

.detail-item label {
  font-weight: 500;
  color: #606266;
  min-width: 80px;
  margin-right: 12px;
}

.detail-item span {
  color: #303133;
  flex: 1;
}

.detail-item .price {
  color: #F56C6C;
  font-weight: 500;
}

/* 操作按钮 */
.action-buttons {
  display: flex;
  gap: 6px;
  flex-wrap: wrap;
  justify-content: center;
}

.action-btn {
  border-radius: 6px;
  font-size: 12px;
  padding: 6px 12px;
  transition: all 0.3s ease;
}

.view-btn {
  background-color: #ECF5FF;
  color: #409EFF;
  border-color: #B3D8FF;
}

.view-btn:hover {
  background-color: #409EFF;
  color: white;
}

.remove-btn {
  background-color: #FEF0F0;
  color: #F56C6C;
  border-color: #FBC4C4;
}

.remove-btn:hover {
  background-color: #F56C6C;
  color: white;
}

.add-btn {
  background-color: #F0F9FF;
  color: #67C23A;
  border-color: #B3E19D;
}

.add-btn:hover {
  background-color: #67C23A;
  color: white;
}

/* 搜索输入框 */
.search-input {
  width: 200px;
}

/* 空状态 */
.empty-state {
  text-align: center;
  padding: 60px 20px;
  color: #909399;
}

.empty-state i {
  font-size: 64px;
  color: #C0C4CC;
  margin-bottom: 20px;
}

.empty-state p {
  font-size: 16px;
  margin: 0;
}

/* 底部操作按钮 */
.bottom-actions {
  display: flex;
  gap: 12px;
  justify-content: center;
  padding: 20px 0;
  margin-top: 20px;
}

.create-btn, .delete-btn {
  border-radius: 8px;
  font-weight: 500;
  padding: 12px 24px;
  transition: all 0.3s ease;
}

.create-btn:hover, .delete-btn:hover {
  transform: translateY(-2px);
  box-shadow: 0 4px 12px rgba(0, 0, 0, 0.15);
}

/* 对话框样式 */
.custom-dialog .el-dialog {
  border-radius: 12px;
}

.custom-dialog .el-dialog__header {
  background: linear-gradient(135deg, #409EFF 0%, #337ECC 100%);
  color: white;
  border-radius: 12px 12px 0 0;
  padding: 20px;
}

.custom-dialog .el-dialog__title {
  color: white;
  font-weight: 600;
}

.custom-dialog .el-dialog__headerbtn .el-dialog__close {
  color: white;
}

.custom-dialog .el-dialog__body {
  padding: 30px;
}

.dialog-form .el-form-item {
  margin-bottom: 20px;
}

.dialog-form .el-form-item__label {
  font-weight: 500;
  color: #606266;
}

.dialog-footer {
  text-align: right;
  padding-top: 20px;
  border-top: 1px solid #EBEEF5;
}

.dialog-footer .el-button {
  border-radius: 6px;
  padding: 10px 20px;
  font-weight: 500;
}

/* 响应式设计 */
@media (max-width: 1200px) {
  .inventory-center {
    flex-direction: column;
    gap: 15px;
  }
  
  .sidebar {
    width: 100%;
  }
  
  .nav-menu {
    display: flex;
    justify-content: center;
    flex-wrap: wrap;
  }
  
  .nav-menu .el-menu-item {
    margin: 4px 8px;
  }
}

@media (max-width: 768px) {
  .inventory-center {
    padding: 10px;
  }
  
  .card-header {
    flex-direction: column;
    align-items: flex-start;
    gap: 15px;
  }
  
  .header-actions {
    width: 100%;
    justify-content: flex-end;
  }
  
  .action-buttons {
    flex-direction: column;
    gap: 4px;
  }
  
  .action-btn {
    width: 100%;
    font-size: 11px;
    padding: 4px 8px;
  }
  
  .search-input {
    width: 100%;
  }
  
  .bottom-actions {
    flex-direction: column;
    gap: 8px;
  }
  
  .create-btn, .delete-btn {
    width: 100%;
  }
  
  .custom-dialog .el-dialog {
    width: 95% !important;
    margin: 0 auto;
  }
}

@media (max-width: 480px) {
  .nav-menu {
    flex-direction: column;
  }
  
  .nav-menu .el-menu-item {
    margin: 2px 0;
  }
  
  .section-title {
    font-size: 16px;
  }
  
  .count-tag {
    font-size: 11px;
  }
}
</style>



// WEBPACK FOOTER //
// src/views/inventory/InventoryCenter.vue